import React from "react";

export default function FilterBar({ status, onStatusChange, tag, onTagChange }) {
  return (
    <div className="filter-bar">
      <select value={status} onChange={(e) => onStatusChange(e.target.value)}>
        <option value="all">All statuses</option>
        <option value="healthy">Healthy</option>
        <option value="degraded">Degraded</option>
        <option value="offline">Offline</option>
      </select>
      <input
        type="text"
        placeholder="Filter by tag..."
        value={tag}
        onChange={(e) => onTagChange(e.target.value)}
      />
    </div>
  );
}
